import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import {
  SubscriptionChangeDialogComponent
} from '@client/shared/components/subscription/subscription-change-dialog/subscription-change-dialog.component';

@Component({
  selector: 'app-subscription-change-disclaimer',
  imports: [
    MatDialogModule,
  ],
  templateUrl: './subscription-change-disclaimer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './subscription-change-disclaimer.component.scss'
})
export class SubscriptionChangeDisclaimerComponent {
  readonly dialogRef = inject(MatDialogRef<SubscriptionChangeDisclaimerComponent>);
  readonly data = inject<{ dialogRef: MatDialogRef<SubscriptionChangeDialogComponent> }>(MAT_DIALOG_DATA);
}
